import { KeyValueModel } from "model/api";
import { EnumTipoControleModulo } from "model/enums/enum-tipo-controle-modulo";

export const TipoControleModuloMock: KeyValueModel[] = [
    new KeyValueModel(EnumTipoControleModulo.NaoControla, "Não Controla"),
    new KeyValueModel(EnumTipoControleModulo.Terminal, "Terminal"),
    new KeyValueModel(EnumTipoControleModulo.Filial, "Filial"),
    new KeyValueModel(EnumTipoControleModulo.ApiReciclagemTributario, "Reciclagem Tributário"),
];